import { useContext, useEffect, useMemo, useState } from "react";
import { Theme, useMediaQuery } from "@mui/material"; 
import { DeviceContext } from "./context/deviceType";
import { UAParser } from "ua-parser-js";

export const getDeviceType = (userAgent: string) => {
    const { device } = new UAParser(userAgent).getResult();
    return device?.type === 'mobile' || device?.type === 'tablet' ? device.type : 'desktop';
}

export const useDeviceType = () => {

    const deviceTypeSSR = useContext(DeviceContext);

    const isMobileBP = useMediaQuery((t: Theme) => t.breakpoints.down('sm'));
    const isTabletBP = useMediaQuery((t: Theme) => t.breakpoints.between('sm', 'md'));

    const [measuredBP, setMeasuredBP] = useState(false);
    useEffect(() => setMeasuredBP(true), []); //Breakpoints runs only on client side , hence marking true right after useeffect runs
    
    const serverSideState = useMemo(() => ({
        isMobile: deviceTypeSSR === 'mobile',
        isTablet: deviceTypeSSR === 'tablet',
        isDesktop: !deviceTypeSSR || deviceTypeSSR === 'desktop',
    }), [deviceTypeSSR]);

     if (!measuredBP) return serverSideState;

    return {
        isMobile: isMobileBP && !isTabletBP,
        isTablet: isTabletBP,
        isDesktop: !isMobileBP && !isTabletBP,
    }
};
